import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "@layout/main-layout/main-layout.component";
import { healthCheckGuard } from "./guards/health-check.guard";

export default [
	{
		path: "health-check",
		component: MainLayoutComponent,
		canActivate: [healthCheckGuard],
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./health-check.component").then(
						(c) => c.HealthCheckComponent,
					),
			},
			{
				path: ":metricId",
				loadComponent: () =>
					import("./health-check-details/health-check-details.component").then(
						(c) => c.HealthCheckDetailsComponent,
					),
			},
		],
	},
] satisfies Routes;
